import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import find from 'lodash-es/find';
import pull from 'lodash-es/pull';


@Component({
    selector: 'app-tag-input',
    templateUrl: './tag-input.component.html',
    styleUrls: ['./tag-input.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: TagInputComponent,
            multi: true,
        }],
    standalone: false
})
export class TagInputComponent implements OnInit {
  @ViewChild('tagInput', { static: true }) tagInputRef: ElementRef;
  @Input('value') _value: any;
  @Input() question;
  @Output() focus_out = new EventEmitter<any>();
  name: string;
  tags: string[] = [];
  form: FormGroup;
  propagateChange = (_: any) => { };

  constructor() { }

  ngOnInit() {
  }

  focusTagInput(): void {
    this.tagInputRef.nativeElement.focus();
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.code === 'Backspace') {
      this.removeTag();
      return;
    } else {
      if (event.code === 'Comma') {
        this.addTag(this.name);
      }
    }
  }

  addTag(tag: string): void {
    this.name = "";
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if (tag.length > 0 && !find(this.tags, tag)) {
      this.tags.push(tag);
    }
    this.value = this.tags;
  }
  sendVal() {
    this.focus_out.emit(this.tags);
  }
  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(-1);
    }
  }
  //for value accessors
  get value() {
    return this._value;
  }

  set value(val) {
    this.tags = val;
    this.propagateChange(val);
  }

  writeValue(value) {
    if (value) {
      this.tags = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }

}
